import { withCompInfo } from '@wix/editor-elements-integrations'
import type { FiveGridLineDefinition, FiveGridLineCSSVars } from './FiveGridLine'

export const css = withCompInfo<FiveGridLineCSSVars, FiveGridLineDefinition>()(
	['compProps', 'compLayout', 'skin', 'styleProperties', 'classicRotation', 'isOneDocMigrated'],
	({ compProps, compLayout, skin, styleProperties, classicRotation, isOneDocMigrated }) => {
		const isLegacyFullScreen = compProps?.fullScreenModeOn === true
		const lineWidthParam = styleProperties.lnw?.split('px')[0] ?? '0'
		const transformOriginY = parseInt(lineWidthParam, 10) === 0 ? 'center' : `${parseFloat(lineWidthParam) / 2}px`
		const isForced3DSkin = skin === 'ZigzagLineSkin' || skin === 'ZigzagLineFlipSkin'
		const rotationInDegrees = isOneDocMigrated ? classicRotation : compLayout.rotationInDegrees
		const transform = isForced3DSkin && rotationInDegrees && `rotate3d(0, 0, 1, ${compLayout.rotationInDegrees}deg)`

		return {
			...(isLegacyFullScreen && {
				left: '0',
				width: '100%',
				'margin-left': '0',
			}),
			...(transform && { transform }),
			'transform-origin': `center ${transformOriginY}`,
			...(styleProperties.brd === '{color_undefined}' && { '--brd': 'var(--color_15)' }),
		}
	}
)
